import React from "react";
import PropTypes from "prop-types";

import { headingSizes, headingTypes } from "core/props";

import Heading from "core/Heading";

import { MaterialUIGridContainer } from "core/MaterialUI";

import {
    BlogPostGrid,
    PostContent,
    ImageContainerWithLink,
    ImageContainer,
    TitleWithLink,
    Title,
    CategoryWithLink,
    Subtitle,
    Links
} from "./styles";
import colors from "core/colors";

const BlogPostsBoxes = ({
    posts,
    subtitleLinkInverse = false,
    blogPostHeadingType,
    blogPostHeadingSize,
    subtitleSize
}) => (
    <MaterialUIGridContainer
        mobileMaxPadding={0}
        // passing in 0 means that we are not using Material UI spacing for mobile; Material UI has trouble with numbers larger than 24 on mobile, so this is done via CSS for this breakpoint.
        tabletMaxPadding={4}
        // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
        desktopMinPadding={9}
        // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of core/MaterialUI/ for this spacing array)
    >
        {posts.map(post => {
            const {
                imageIsLink,
                headingIsLink,
                subtitleIsLink,
                title,
                subtitle,
                category,
                imgSrc,
                url,
                target,
                links
            } = post;

            return (
                <BlogPostGrid item sm={12} md={4} lg={4} key={title}>
                    <PostContent>
                        {imageIsLink ? (
                            <ImageContainerWithLink
                                href={url}
                                target={target ? target : "_self"}
                            >
                                <img src={imgSrc} title={title} />
                            </ImageContainerWithLink>
                        ) : (
                            <ImageContainer>
                                <img src={imgSrc} title={title} />
                            </ImageContainer>
                        )}

                        <Heading
                            type={
                                blogPostHeadingType ? blogPostHeadingType : "h6"
                            }
                            size={
                                blogPostHeadingSize ? blogPostHeadingSize : "xs"
                            }
                        >
                            {headingIsLink ? (
                                <TitleWithLink
                                    href={url}
                                    target={target ? target : "_self"}
                                >
                                    {title}
                                </TitleWithLink>
                            ) : (
                                <Title>{title}</Title>
                            )}
                        </Heading>

                        <Subtitle
                            type="div"
                            size={subtitleSize ? subtitleSize : "lg"}
                            copyColor={colors.storm}
                            subtitleIsLink={subtitleIsLink}
                        >
                            {subtitleIsLink ? (
                                <span>
                                    <CategoryWithLink
                                        subtitleLinkInverse={
                                            subtitleLinkInverse
                                        }
                                        href={url}
                                        target={target ? target : "_self"}
                                    >
                                        {category}
                                    </CategoryWithLink>
                                </span>
                            ) : (
                                subtitle
                            )}
                        </Subtitle>

                        {links && (
                            <Links>
                                {links.map(link => {
                                    const Icon = link.icon;
                                    return (
                                        <a
                                            key={link.altInfo}
                                            href={link.url}
                                            target="_blank"
                                            aria-label={link.altInfo}
                                        >
                                            <Icon
                                                title={link.altInfo}
                                                fillColor={colors.storm}
                                                size="lg"
                                            />
                                        </a>
                                    );
                                })}
                            </Links>
                        )}
                    </PostContent>
                </BlogPostGrid>
            );
        })}
    </MaterialUIGridContainer>
);

BlogPostsBoxes.propTypes = {
    posts: PropTypes.array.isRequired,
    subtitleLinkInverse: PropTypes.bool,
    blogPostHeadingType: PropTypes.oneOf(headingTypes),
    blogPostHeadingSize: PropTypes.oneOf(headingSizes),
    subtitleSize: PropTypes.oneOf(headingSizes)
};

export default BlogPostsBoxes;

// This is being used in nounproject/www/static/assets/js/components/Leadership/index.js
